import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './EditProfile.css';

const EditProfile: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('أحمد محمد');
  const [phone, setPhone] = useState('+961 70 123 456');
  const [email, setEmail] = useState('ahmed@example.com');

  const handleSave = () => {
    // Save profile logic
    console.log('Saving profile', { username, phone, email });
    navigate('/profile');
  };

  return (
    <div className="edit-profile-page">
      <header className="edit-profile-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>Edit Profile</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="edit-profile-content">
        <div className="avatar-section">
          <div className="user-avatar-large">👤</div>
          <button className="change-avatar-button">Change Photo</button>
        </div>

        <form className="edit-profile-form">
          <div className="form-group">
            <label>اسم المستخدم</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="أدخل اسم المستخدم"
            />
          </div>

          <div className="form-group">
            <label>رقم الموبايل</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="أدخل رقم الموبايل"
            />
          </div>

          <div className="form-group">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="أدخل البريد الإلكتروني"
            />
          </div>

          <button type="button" className="save-button" onClick={handleSave}>
            حفظ التغييرات
          </button>
        </form>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default EditProfile;

